import React from 'react';
import styles from './styles.module.css';

const Radio = ({ name, value, checked = false, onChange, label }) => {
  return (
    <>
      <input
        className={styles.radio}
        type='radio'
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
    </>
  );
};

export default Radio;
